/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiFormSectionColumnConfig} from "./UiFormSectionColumnConfig";
import {UiFormSectionRowConfig} from "./UiFormSectionRowConfig";
import {UiFormSectionPlacementConfig} from "./UiFormSectionPlacementConfig";
import {UiSpacingConfig} from "./UiSpacingConfig";
import {UiBorderConfig} from "./UiBorderConfig";
import {UiShadowConfig} from "./UiShadowConfig";
import {UiColorConfig} from "./UiColorConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";


export interface UiFormSectionConfig {
	_type?: string;
	id: string;
	columns: UiFormSectionColumnConfig[];
	rows: UiFormSectionRowConfig[];
	fieldPlacements: UiFormSectionPlacementConfig[];
	margin?: UiSpacingConfig;
	padding?: UiSpacingConfig;
	border?: UiBorderConfig;
	shadow?: UiShadowConfig;
	backgroundColor?: UiColorConfig;
	collapsible?: boolean;
	collapsed?: boolean;
	visible?: boolean;
	headerTemplate?: UiTemplateConfig;
	headerData?: any;
	drawHeaderLine?: boolean;
	gridGap?: number;
	fillRemainingHeight?: boolean;
	hideWhenNoVisibleFields?: boolean
}

